<template>
  <div class="myusers f-s-s f-d-c w-100 p-4">
    <div class="editHead w-100 f-c-b mb-3">
      <div class="right f-c-s">
        <b-img
          class="title-icon ml-2"
          :src="require(`@/assets/images/gap/details-meeting.svg`)"
        ></b-img>
        <div class="title-text f-c-c">ویرایش گروه های کاربری</div>
      </div>
      <div class="return f-c-c returnBtn" @click="returnFunc()">
        <!-- <div class="arrow f-c-c mr-1">&lt;</div> -->
        <div class="returnText f-c-c">برگشت</div>
      </div>
    </div>
    <div class="editTitle f-c-s w-100 mb-3">
      <div class="label f-c-c ml-2 pb-1">عنوان :</div>
      <div class="mainTitle f-c-c pb-1">
        <div class="text f-c-c">{{ title }}</div>
        <b-img
          v-if="user.permissions.edit_user_group"
          @click="titleEditFunc()"
          class="title-icon mr-2"
          :src="require(`@/assets/images/gap/edit-pen.svg`)"
        ></b-img>
      </div>
    </div>
    <div class="header f-c-b w-100 mb-3">
      <div class="tableTitle">لیست کاربران</div>
      <div class="f-c-e searchBox">
        <div class="search f-c-c">
          <input
            v-if="isSearchActive"
            :class="[isSearchActive ? 'searchInputActive' : '']"
            @keyup="searchFunc"
            type="text"
            placeholder="جستجو"
          />
          <b-img
            :class="[isSearchActive ? 'imgActive' : '']"
            :src="require(`@/assets/images/gap/search-icon.svg`)"
            @click="searchIconFunc()"
          ></b-img>
        </div>
        <div
          v-if="user.permissions.edit_user_group"
          @click.prevent="addNewUserFunc()"
          class="addUser f-c-c"
        >
          <span class="plus ml-2">+</span>
          <div class="text f-c-c">افزودن کاربر</div>
        </div>
      </div>
      <!-- <div class="search f-c-c">
        <b-img :src="require(`@/assets/images/gap/search-icon.svg`)"></b-img>
        <input v-model="searchUser" type="text" placeholder="جستجو" />
      </div>
      <div @click.prevent="addNewUserFunc()" class="addUser f-c-c">
        <span class="plus ml-2">+</span>
        <div class="text f-c-c">افزودن کاربر</div>
      </div> -->
    </div>
    <div class="userTable usergroupTable f-c-s f-d-c w-100">
      <div class="header f-c-s w-100">
        <div class="headerItem f-c-s"></div>
        <div class="headerItem f-c-s w-40">نام</div>
        <div class="headerItem f-c-s w-25">موبایل</div>
        <!-- <div class="headerItem f-c-s">ایمیل</div> -->
        <div class="headerItem f-c-s w-25"></div>
      </div>
      <div v-if="itemsForList.length" class="tableContent f-c-s f-d-c w-100">
        <div
          v-for="(v, i) in itemsForList"
          :key="i"
          class="tableRow f-c-s w-100"
        >
          <div class="tableItem f-c-c">{{ v.row }}</div>
          <div class="tableItem f-c-s w-40">
            <div
              class="f-c-s w-90"
              :title="v.first_name + ' ' + v.last_name"
              style="
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              "
            >
              {{ v ? v.first_name + " " + v.last_name : "-" }}
            </div>
          </div>
          <div class="tableItem f-c-s w-25">{{ v.mobile ? v.mobile : "-" }}</div>
          <!-- <div class="tableItem f-c-s">
            <div
              class="f-c-s w-90"
              :title="v.email"
              style="
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              "
            >
              {{ v.email ? v.email : "-" }}
            </div>
          </div> -->
          <div class="tableItem f-c-c w-25">
            <!-- <b-img
              @click.prevent="editUserFunc(v)"
              class="ml-2 cp"
              :src="require(`@/assets/images/gap/edit-icon.svg`)"
            ></b-img> -->
            <!-- <b-img
              class="cp"
              @click.prevent="deleteUserFunc(v)"
              :src="require(`@/assets/images/gap/delete-icon.svg`)"
            ></b-img> -->
            <div
              v-if="user.permissions.edit_user_group"
              class="deleteBtn f-c-c"
              @click.prevent="deleteUserFunc(v)"
            >
              حذف
            </div>
          </div>
        </div>
      </div>
      <div v-else class="tableContent emptyTable f-c-c w-100 h-100">
        کاربری وجود ندارد.
      </div>
      <div class="paginationSection f-c-c w-100">
        <b-pagination
          v-model="currentPage"
          :total-rows="rows"
          :per-page="perPage"
          aria-controls="my-table"
        ></b-pagination>
      </div>
    </div>
    <div v-if="itemsForList.length" class="mobileUserTable f-c-s f-d-c w-100">
      <div
        v-for="(v, i) in itemsForList"
        :key="i"
        class="tableItem f-c-s f-d-c w-100 mb-3"
      >
        <div class="up f-c-b w-100 mb-3">
          <div class="right f-s-s f-d-c">
            <div class="labelItem f-c-c mb-2">نام :</div>
            <div class="labelItem f-c-c">موبایل :</div>
            <!-- <div class="labelItem f-c-c">ایمیل :</div> -->
          </div>
          <div class="left f-e-e f-d-c">
            <div class="answerItem f-c-e mb-2">
              {{ v ? v.first_name + " " + v.last_name : "-" }}
            </div>
            <div class="answerItem f-c-e">
              {{ v.mobile ? v.mobile : "-" }}
            </div>
            <!-- <div class="answerItem f-c-e">
              {{ v.email ? v.email : "-" }}
            </div> -->
          </div>
        </div>
        <div class="down f-c-c w-100">
          <!-- <div class="edit f-c-c" @click.prevent="editGroupFunc(v)">
            <b-img
              :src="require(`@/assets/images/mobile/edit-pen.svg`)"
            ></b-img>
          </div> -->
          <div
            v-if="user.permissions.edit_user_group"
            class="delete f-c-c"
            @click.prevent="deleteUserFunc(v)"
          >
            <b-img
              :src="require(`@/assets/images/mobile/delete-x.svg`)"
            ></b-img>
          </div>
        </div>
      </div>
    </div>
    <div
      v-else
      class="mobileUserTable tableContent emptyTable f-c-c w-100 h-100"
    >
      کاربری وجود ندارد.
    </div>
    <b-modal
      id="edit-modal"
      title="ویرایش"
      button-size="sm"
      :hide-footer="footer"
      ref="editGroup-modal"
    >
      <template class="content f_s_s f-d-c w-100">
        <div class="row f-c-c w-100 mb-5 mt-3">
          <div class="label f-c-s">عنوان</div>
          <input v-model="title" type="text" />
        </div>
        <div class="btnSec w-100 f-c-c mb-3">
          <div class="finalbtn f-c-c" @click="saveGroupFunc()">ذخیره</div>
        </div>
      </template>
    </b-modal>
    <b-modal
      id="edit-modal"
      title="ویرایش"
      button-size="sm"
      :hide-footer="footer"
      ref="edit-modal"
    >
      <template class="content f_s_s f-d-c w-100">
        <div class="row f-c-c w-100 mb-3">
          <div class="label f-c-s">نام</div>
          <input v-model="editUser.name" type="text" />
        </div>
        <div class="row f-c-c w-100 mb-3">
          <div class="label f-c-s">نام خانوادگی</div>
          <input v-model="editUser.family" type="text" />
        </div>
        <!-- <div class="row f-c-c w-100 mb-3">
          <div class="label f-c-s">ایمیل</div>
          <input v-model="editUser.email" type="email" />
        </div> -->
        <div class="row f-c-c w-100 mb-3">
          <div class="label f-c-s">موبایل</div>
          <input v-model="editUser.mobile" type="number" />
        </div>
        <!-- <div class="row f-c-c w-100 mb-4">
          <div class="label f-c-s">نقش</div>
          <select class="gender" v-model="editUser.role">
            <option v-for="(v, i) in roles" :key="i" :value="v.id">
              {{ v.name }}
            </option>
          </select>
        </div> -->
        <div class="btnSec w-100 f-c-c">
          <div class="finalbtn f-c-c">ذخیره</div>
        </div>
      </template>
    </b-modal>
    <b-modal
      id="add-modal"
      title="افزودن کاربر"
      button-size="sm"
      :hide-footer="footer"
      ref="add-modal"
    >
      <template class="content f_s_s f-d-c w-100">
        <div class="addUserBox f-c-s f-d-c w-100 h-100">
          <div class="header f-c-b w-100">
            <div
              v-for="(v, i) in headerItem"
              :key="i"
              class="item f-c-c"
              @click.prevent="activeId = i"
              :class="[activeId == i ? 'active' : '']"
            >
              {{ v }}
            </div>
          </div>
          <div v-if="activeId == 0" class="singleSec f-c-c f-d-c w-100">
            <div class="row f-c-c w-100 mb-4">
              <div class="label f-c-s">موبایل</div>
              <input v-model="addUser.mobile" type="number" />
            </div>
            <div class="row f-c-c w-100 mb-4">
              <div class="label f-c-s">نام</div>
              <input v-model="addUser.name" type="text" />
            </div>
            <div class="row f-c-c w-100 mb-4">
              <div class="label f-c-s">نام خانوادگی</div>
              <input v-model="addUser.family" type="text" />
            </div>
            <!-- <div class="row f-c-c w-100 mb-5">
              <div class="label f-c-s">ایمیل</div>
              <input v-model="addUser.email" type="email" />
            </div> -->
            <div class="btnSec w-100 f-c-c">
              <div class="finalbtn f-c-c" @click="addUserSingleFunc()">
                ذخیره
              </div>
            </div>
          </div>
          <div v-if="activeId == 1" class="singleSec f-c-c f-d-c w-100">
            <div class="dragSection f-c-c w-50 mb-4">
              <b-form-group
                id="fileInputForum"
                class="dragdrop m-0 f-c-c f-d-c w-100 h-100"
              >
                <b-form-file
                  accept=".xlsx, .xls"
                  drop-placeholder="رها کنید"
                  ref="excel-input"
                  @input="addFileFunc"
                >
                  <template slot="placeholder">
                    <b-img
                      :src="require(`@/assets/images/gap/excel-icon.svg`)"
                    ></b-img>
                    <div class="text f-c-c">
                      <div class="plus ml-2">+</div>
                      <div class="value f-c-c">
                        {{ "افزودن فایل اکسل" }}
                      </div>
                    </div>
                  </template>
                  <template slot="file-name">
                    <b-img
                      :src="require(`@/assets/images/gap/excel-icon.svg`)"
                    ></b-img>
                    <div class="text f-c-c">
                      <div class="plus ml-2">+</div>
                      <div class="value f-c-c">
                        {{ "افزودن فایل اکسل" }}
                      </div>
                    </div>
                  </template>
                </b-form-file>
              </b-form-group>
            </div>
            <div class="sampleExcel f-c-c w-100 mb-4">
              <a
                :href="require(`@/assets/excel/sample_group_user_excel.xlsx`)"
                download
                >دانلود نمونه فایل اکسل</a
              >
            </div>
            <div class="btnSec excelBtn w-100 f-c-c mb-3">
              <div class="finalbtn f-c-c" @click="addUserWithExcelFunc()">
                ذخیره
              </div>
            </div>
            <div v-if="addUser.file && addUser.file.name" class="fileList">
              <div class="fileList-item f_c_c">
                <a href="#" class="value">{{ addUser.file.name }}</a>
                <span class="close-btn mr-2" @click.prevent="deleteFileFunc()"
                  >&times;</span
                >
              </div>
            </div>
          </div>
        </div>
      </template>
    </b-modal>
    <DeleteConfirm v-if="isDelete" message="از حذف کاربر مطمئن هستید ؟" />
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import DeleteConfirm from "@/components/DelConfirmModal";
import { EventBus } from "@/assistant/EventBus";
export default {
  name: "UserGroupEdit",
  data() {
    return {
      iswatie: false,
      isSearchActive: false,
      title: "",
      activeId: 0,
      editUser: {
        name: "",
        family: "",
        email: "",
        mobile: "",
        role: "",
      },
      headerItem: ["تکی", "اکسلی"],
      addUser: {
        name: "",
        family: "",
        email: "",
        mobile: "",
        role: "",
        file: {},
      },
      currentPage: 1,
      perPage: 15,
      footer: true,
      isDelete: false,
      userDeleted: {},
      userEdited: {},
      roles: [
        { id: 1, name: "دانشجو" },
        { id: 2, name: "میهمان" },
      ],
      allUsers: [],
      users: [],
    };
  },
  created() {
    this.getGroupUsersFunction({
      user_id: this.user.user_id,
      user_group_id: this.groupEdited.id,
    });
    EventBus.$on("deleteItem", (status) => {
      if (status && this.isDelete) {
        this.deleteUserInGroupFunction({
          user_id: this.user.user_id,
          user_group_id: this.groupEdited.id,
          user_group_user_id: this.userDeleted.id,
        });
      }
      this.isDelete = false;
    });
  },
  computed: {
    ...mapState({
      user: (state) => state.gap.user,
      allGroupUser: (state) => state.gap.allGroupUser,
      groupEdited: (state) => state.gap.groupEdited,
      changeTitleStatus: (state) => state.gap.changeTitleStatus,
      addUserSingleStatus: (state) => state.gap.addUserSingleStatus,
      addUserWithExcelStatus: (state) => state.gap.addUserWithExcelStatus,
      deleteUserFromGroupStatus: (state) => state.gap.deleteUserFromGroupStatus,
    }),
    rows() {
      return this.users.length;
    },
    itemsForList() {
      return this.users.slice(
        (this.currentPage - 1) * this.perPage,
        this.currentPage * this.perPage
      );
    },
  },
  components: {
    DeleteConfirm,
  },
  methods: {
    ...mapActions("gap", [
      "getGroupUsersFunction",
      "setTitleGroupFunction",
      "deleteUserInGroupFunction",
      "addUserSingleFunction",
      "addUserWithExcelFunction",
    ]),
    searchFunc(v){
      let n = v.target.value
      if (this.allGroupUser.user_group_users) {
        let searchArray = this.allGroupUser.user_group_users.filter(
          (ticket) => {
            return (
              ticket.first_name.toLowerCase().includes(n) ||
              ticket.last_name.toLowerCase().includes(n) ||
              ticket.mobile.toLowerCase().includes(n)
            );
          }
        );
        this.users = searchArray;
      }
    },
    searchIconFunc() {
      this.isSearchActive = !this.isSearchActive;
      setTimeout(() => {
        if (this.isSearchActive) {
          document.querySelector(".searchInputActive").focus();
        }
      }, 200);
    },
    titleEditFunc() {
      this.$refs["editGroup-modal"].show();
    },
    mobileNumber(Number) {
      var IndNum = /^[0]?[789]\d{9}$/;

      if (IndNum.test(Number) && Number.length == 11) {
        return true;
      } else {
        return false;
      }
    },
    validateEmail(email) {
      return email.match(
        /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
    },
    addUserSingleFunc() {
      if (
        this.addUser.name == "" ||
        this.addUser.mobile == "" ||
        this.addUser.family == ""
      ) {
        this.$bvToast.toast("پر کردن تمام موارد الزامی می باشد.", {
          title: "خطا",
          variant: "danger",
          solid: true,
        });
      } else if (
        !this.mobileNumber(this.addUser.mobile)
      ) {
        this.$bvToast.toast("تلفن همراه را بصورت صحیح وارد نمایید.", {
          title: "خطا",
          variant: "danger",
          solid: true,
        });
      } else {
        this.addUserSingleFunction({
          first_name: this.addUser.name,
          last_name: this.addUser.family,
          // email: this.addUser.email,
          mobile: this.addUser.mobile,
          user_id: this.user.user_id,
          user_group_id: this.groupEdited.id,
        });
      }
    },
    addUserWithExcelFunc() {
      this.addUserWithExcelFunction({
        excel: this.addUser.file,
        user_id: this.user.user_id,
        user_group_id: this.groupEdited.id,
      });
    },
    saveGroupFunc() {
      this.setTitleGroupFunction({
        user_id: this.user.user_id,
        user_group_id: this.groupEdited.id,
        title: this.title,
      });
    },
    returnFunc() {
      this.$router.push({ name: "userGroups" });
    },
    addFileFunc(e) {
      if (e) {
        if (this.addUser.file && this.addUser.file.name) {
          this.$bvToast.toast("تنها مجاز به ارسال یک فایل می باشید.", {
            title: "خطا",
            variant: "danger",
            solid: true,
          });
        } else {
          this.addUser.file = e;
        }
      }
    },
    deleteFileFunc() {
      this.$refs["excel-input"].reset();
      this.addUser.file = {}
    },
    editUserFunc(v) {
      this.userEdited = v;
      this.editUser.name = v.first_name;
      this.editUser.family = v.last_name;
      // this.editUser.email = v.email;
      this.editUser.mobile = v.mobile;
      // this.editUser.role = v.roleId;
      this.$refs["edit-modal"].show();
    },
    deleteUserFunc(v) {
      this.isDelete = true;
      this.userDeleted = v;
    },
    addNewUserFunc() {
      this.$refs["add-modal"].show();
    },
  },
  watch: {
    deleteUserFromGroupStatus(n) {
      if (Object.keys(n).length) {
        if (n.code == 100) {
          this.getGroupUsersFunction({
            user_id: this.user.user_id,
            user_group_id: this.groupEdited.id,
          });
          this.$bvToast.toast(n.message, {
            title: "تایید",
            variant: "success",
            solid: true,
          });
        } else {
          this.$bvToast.toast(n.message, {
            title: "خطا",
            variant: "danger",
            solid: true,
          });
        }
      }
    },
    addUserSingleStatus(n) {
      if (Object.keys(n).length) {
        if (n.code == 100) {
          this.getGroupUsersFunction({
            user_id: this.user.user_id,
            user_group_id: this.groupEdited.id,
          });
          this.$bvToast.toast(n.message, {
            title: "تایید",
            variant: "success",
            solid: true,
          });
          this.addUser.name = "";
          this.addUser.family = "";
          // this.addUser.email = "";
          this.addUser.mobile = "";
          this.addUser.file = {};
          this.activeId = 0;
          this.$refs["add-modal"].hide();
        } else {
          this.$bvToast.toast(n.message, {
            title: "خطا",
            variant: "danger",
            solid: true,
          });
        }
      }
    },
    addUserWithExcelStatus(n) {
      if (Object.keys(n).length) {
        if (n.code == 100) {
          this.getGroupUsersFunction({
            user_id: this.user.user_id,
            user_group_id: this.groupEdited.id,
          });
          this.$bvToast.toast(n.message, {
            title: "تایید",
            variant: "success",
            solid: true,
          });
          this.addUser.name = "";
          this.addUser.family = "";
          // this.addUser.email = "";
          this.addUser.mobile = "";
          this.addUser.file = {};
          this.activeId = 0;
          this.$refs["add-modal"].hide();
        } else {
          this.$bvToast.toast(n.message, {
            title: "خطا",
            variant: "danger",
            solid: true,
          });
        }
      }
    },
    changeTitleStatus(n) {
      if (Object.keys(n).length) {
        if (n.code == 100) {
          this.$refs["editGroup-modal"].hide();
          this.getGroupUsersFunction({
            user_id: this.user.user_id,
            user_group_id: this.groupEdited.id,
          });
          this.$bvToast.toast(n.message, {
            title: "تایید",
            variant: "success",
            solid: true,
          });
        } else {
          this.$bvToast.toast(n.message, {
            title: "خطا",
            variant: "danger",
            solid: true,
          });
        }
      }
    },
    allGroupUser(n) {
      if (Object.keys(n).length) {
        this.title = n.title;
        if (n.code == 100) {
          this.users = n.user_group_users;
        } else {
          this.iswatie = true;
          this.users = [];
        }
      }
    },
  },
  mounted() {
    if (Object.keys(this.allGroupUser).length) {
      this.title = this.allGroupUser.title;
      if (this.allGroupUser.code == 100) {
        this.users = this.allGroupUser.user_group_users;
      } else {
        this.iswatie = true;
      }
    }
  },
};
</script>